import aarhusguidenConstructCard from "./aarhusguiden-construct-card";

export function aarhusguidenFilter(){
    if(document.querySelector('.js-aarhusguiden')){
        const currentUrl = window.location.origin;
        const baseUrl = 'https://api.detskeriaarhus.dk/api/v2/daily_occurrences'
        const accessToken = 'iw1pvLnjtBM0AvNG7TeH7ZT4ukNYgpdAWxUZ96Rc';

        const element = document.querySelector('.js-aarhusguiden')
        $( "#aarhusguiden-datepicker-from" ).datepicker({
            onSelect: datePickerFrom,
            dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
            dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
            firstDay: 1,
            monthNames: [ "Januar", "Februar", "Marts", "April", "Maj", "Juni", "Juli", "August", "September", "Oktober", "November", "December" ]
          });
        $( "#aarhusguiden-datepicker-to" ).datepicker({
            onSelect: datePickerTo,
            dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
            dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
            firstDay: 1,
            monthNames: [ "Januar", "Februar", "Marts", "April", "Maj", "Juni", "Juli", "August", "September", "Oktober", "November", "December" ]
          });

        //set "to" date to x number of days ahead
        const daysAhead = element.getAttribute('data-days') ? parseInt(element.getAttribute('data-days')) : 7;
        const dateAhead = new Date();
        dateAhead.setDate(dateAhead.getDate() + daysAhead);
        $("#aarhusguiden-datepicker-to").datepicker("setDate", dateAhead);

        //fetch variables
        let tagsParam = [];
        let dateFromParam = '';
        let dateToParam = '';
        let numberParam = element.getAttribute('data-number') ? element.getAttribute('data-number') : 6;
        let pageParam = 1;
        let fetchUrl = '';
        let dataUrl = element.getAttribute('data-url') ? element.getAttribute('data-url') : '';
        let totalItems;
        let searchParam = false;
        let accessParam = element.getAttribute('data-access') ? `&event.publicAccess=${element.getAttribute('data-access')}` : '';
        let locationIdParam = element.getAttribute('data-location') ? `&event.location.entityId=${encodeURIComponent(element.getAttribute('data-location'))}` : '';
        let organizerIdParam = element.getAttribute('data-organizer') ? `&event.organizer.entityId=${encodeURIComponent(element.getAttribute('data-organizer'))}` : '';

        //get default dateParams
        // Extract year, month, and day components
        let currentDate = new Date();
        function convertDate(date, variable){
            let year = date.getFullYear();
            let month = ('0' + (date.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() returns zero-based month index
            let day = ('0' + date.getDate()).slice(-2);
            return year + '-' + month + '-' + day;
        }

        // Format the date as "YYYY-MM-DD"
        const defaultDateFrom = convertDate(currentDate) + 'T00:00:00Z'
        const defaultDateTo = convertDate(dateAhead) + 'T23:59:59Z'

        dateFromParam = encodeURIComponent(defaultDateFrom);
        dateToParam = encodeURIComponent(defaultDateTo);

        //element variables
        const cardsContainer = document.querySelector('.aarhusguiden__cards-container .row');
        const searchFormElement = document.querySelector('.aarhusguiden__search-container').querySelector('form');

        //default tagsParam (all available tags in all categories)
        const tagElements = document.querySelectorAll('.js-aarhusguiden-category')

        // If default tag selection is supposed to be all used tags, this code can be used
        let defaultTags = Array.from(tagElements).map(item => {
            let tagString = item.getAttribute('data-tags');
            return tagString.replace(/[a-zA-ZøØæÆåÅ\s]/g, match => encodeURIComponent(match));
        }).join(',')

        //If default tag selection is supposed to be all events, this code can be used
        /*let defaultTags = ''*/

        tagsParam = defaultTags

        //init fetch
        fetchData()

        //tagElements onclick function
        const handleTagClick = (item) => {
            clear();

            item.classList.toggle('tag--underline')

            // Get all currently selected tags
            let selectedTagsElements = element.querySelectorAll('.tag--underline');
            let selectedTags = Array.from(selectedTagsElements).map(item => {
                let singleTagsString = item.getAttribute('data-tags');
                // Encode letters and spaces in the tag string
                return singleTagsString.replace(/[a-zA-ZøØæÆåÅ\s]/g, match => encodeURIComponent(match));
            }).join(',');

            //if no selected tags, return to default tags
            if(selectedTags.length != 0){
                tagsParam = selectedTags;
            } else {
                tagsParam = defaultTags;
            }

            //reset page param
            pageParam = 1;

            //fetch from API based on new tags
            fetchData();
        }

        //tags onclick
        tagElements.forEach((item) => {
            //add event listener
            item.addEventListener('click', () => handleTagClick(item))
            item.addEventListener('keydown', (event) => {
                if(event.key == 'Enter'){
                    handleTagClick(item)
                }
            })
        })

        //clear cards container and reset page param
        function clear(){
            pageParam = 1;
            searchParam = false;
            tagsParam = defaultTags;
            cardsContainer.innerHTML = ''

        }

        //search input
        searchFormElement.addEventListener('submit', (e) => {
            e.preventDefault();
            pageParam = 1;
            cardsContainer.innerHTML = '';
            searchParam = encodeURIComponent(e.target[0].value);
            fetchData();
        })

        //convert output date to API date format (DD/MM/YYYY to YYYY-MM-DD)
        function convertDateFormat(inputDate){
            const year = inputDate.substring(6,10);
            const month = inputDate.substring(0,2)
            const day = inputDate.substring(3,5)
            return `${year}-${month}-${day}`
        }

        //date from onclick
        function datePickerFrom(dateText){
            dateFromParam = convertDateFormat(dateText)
            dateFromParam += 'T00:00:00Z';
            dateFromParam = encodeURIComponent(dateFromParam);
            clear();
            fetchData()
        }

        //date to onclick
        function datePickerTo(dateText){
            dateToParam = convertDateFormat(dateText)
            dateToParam += 'T23:59:59Z'
            dateToParam = encodeURIComponent(dateToParam)
            clear();
            fetchData();
        }

        //today button
        const todayBtnElement = document.querySelector('.js-aarhusguiden-today-btn');
        todayBtnElement.addEventListener('click', (e) => {
            e.preventDefault();
            //reset page param
            clear();
            $('#aarhusguiden-datepicker-from').datepicker('setDate', new Date());
            $('#aarhusguiden-datepicker-to').datepicker('setDate', new Date());

            dateFromParam = encodeURIComponent(defaultDateFrom);
            dateToParam = defaultDateFrom.substring(0,11) + '23:59:59Z';
            dateToParam = encodeURIComponent(dateToParam)

            //fetch data from API
            fetchData();
        })

        //reset button
        const resetBtnElement = document.querySelector('.js-aarhusguiden-reset-btn');
        resetBtnElement.addEventListener('click', (e) => {
            e.preventDefault();
            //reset page param
            clear();

            $('#aarhusguiden-datepicker-from').datepicker('setDate', new Date());
            $("#aarhusguiden-datepicker-to").datepicker("setDate", dateAhead);

            tagElements.forEach((item) => {
                item.classList.remove('tag--underline')
            })
            dateFromParam = encodeURIComponent(defaultDateFrom)
            dateToParam = encodeURIComponent(defaultDateTo)

            //fetch data again
            fetchData();

        })

        //fetch data function
        async function fetchData(){

            //separate fetch for search only if search param is set
            if(searchParam){
                fetchUrl = `${baseUrl}?page=${pageParam}&itemsPerPage=${numberParam}&event.title=${searchParam}${locationIdParam}${organizerIdParam}&start=${encodeURIComponent(defaultDateFrom)}`
                const response = await fetch(fetchUrl, {
                    headers: {
                        'Origin': currentUrl,
                        'X-Api-Key': accessToken
                    }
                })
                if(response.ok){
                    const events = await response.json()
                    totalItems = events['hydra:member'];
                    totalItems.forEach((item) => {
                        aarhusguidenConstructCard(item, cardsContainer, dataUrl)
                    })
                }
            } else {
                fetchUrl = `${baseUrl}?page=${pageParam}&itemsPerPage=${numberParam}&event.tags=${encodeURIComponent(tagsParam)}&start=${dateFromParam}&end=${dateToParam}${locationIdParam}${organizerIdParam}${accessParam}`
                const response = await fetch(fetchUrl, {
                    headers: {
                        'Origin': currentUrl,
                        'X-Api-Key': accessToken
                    }
                })
                if(response.ok){
                    const events = await response.json()
                    totalItems = events['hydra:member'];
                    totalItems.forEach((item) => {
                        aarhusguidenConstructCard(item, cardsContainer, dataUrl)
                    })
                }
            }

            pageParam ++;
        }

        //load more
        const loadMoreBtnElement = document.querySelector('.js-aarhusguiden-load-more-btn')
        loadMoreBtnElement.addEventListener('click', (e) => {
            e.preventDefault();
            fetchData();
        })

    }
}

export default aarhusguidenFilter;
